document.addEventListener('DOMContentLoaded', () => {
    const gamesContainer = document.getElementById('category-games-container') as HTMLElement | null;
    if (!gamesContainer) return;

    const gamesList = document.getElementById('games-container') as HTMLUListElement | null;
    if (!gamesList) return;

    const loadMoreBtn = document.getElementById('load-more-btn') as HTMLButtonElement | null;
    if (!loadMoreBtn) {
        console.warn('[Category] #load-more-btn not found');
        return;
    }

    const allGamesSlug = (gamesContainer.dataset.allGamesSlug || '').trim();
    // CRM-configurable category to show on initial load; falls back to All games.
    const defaultCategory = (gamesContainer.dataset.defaultCategory || allGamesSlug).trim();
    const shouldSyncUrl = gamesContainer.dataset.syncUrl !== 'false';

    const getSlugFromUrl = () =>
        shouldSyncUrl
            ? (new URL(window.location.href).searchParams.get('category') || defaultCategory).trim()
            : defaultCategory;

    const setActive = (slug: string) => {
        document.querySelectorAll<HTMLElement>('.js-cat-filter').forEach((a) => {
            const isActive = (a.dataset.filterCat || '').trim() === slug;
            a.classList.toggle('active', isActive);
            if (isActive) a.setAttribute('aria-current', 'true');
            else a.removeAttribute('aria-current');
        });
    };

    const nextFrame = () => new Promise<void>((r) => requestAnimationFrame(() => r()));

    const showLoading = async () => {
        gamesContainer.classList.add('is-loading');
        await nextFrame();
    };

    const hideLoading = () => {
        gamesContainer.classList.remove('is-loading');
    };

    const loadCategory = async (slug: string) => {
        loadMoreBtn.dataset.category = slug;
        loadMoreBtn.dataset.currentPage = '1';

        await window.loadMoreGames.resetAndLoadFirstPage();
    };

    const apply = async (slug: string, pushToHistory: boolean) => {
        const finalSlug = (slug || defaultCategory).trim();

        setActive(finalSlug);

        if (pushToHistory && shouldSyncUrl) {
            const u = new URL(window.location.href);
            u.searchParams.set('category', finalSlug);
            window.history.pushState({ category: finalSlug }, '', u);
        }

        await showLoading();

        try {
            await loadCategory(finalSlug);
        } catch (e) {
            console.error('[Category] loadCategory error:', e);
        } finally {
            hideLoading();
        }
    };

    document.querySelectorAll<HTMLElement>('.js-cat-filter').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const slug = (el.dataset.filterCat || '').trim();
            if (!slug) return;
            void apply(slug, true);
        });
    });

    void apply(getSlugFromUrl(), false);

    window.addEventListener('popstate', () => {
        void apply(getSlugFromUrl(), false);
    });
});
